import * as React from 'react';
import './Group.css';
import { inject, observer } from 'mobx-react';
import { AppStore } from '../../../../stores';
import GroupService from '../../../../services/GroupService';
import { IMyGroup } from '../../../../interfaces/IMyGroup';
import ProductService from '../../../../services/ProductService';
import { IType } from '../../../../interfaces/IType';
export interface IProps {
  appStore?: AppStore;
  group: IMyGroup;
  isAdmin?: boolean;
  showResultButton?: boolean;
  style?: React.CSSProperties;
  getMyGroups: (group: IMyGroup) => void;
}

export interface IState {
  hasAccess: boolean;
}

@inject('appStore')
@observer
export default class Group extends React.Component<IProps, IState> {

  constructor(props) {
    super(props);
    this.state = {
      hasAccess: false
    }
  }

  render() {
    return (
      <div
        className='groupInvitation'
        style={this.props.style}
      >
        {this.props.isAdmin &&
          <div
            className="groupInvitationEditButton"
            style={{
              backgroundImage: `url("https://img.icons8.com/external-anggara-basic-outline-anggara-putra/96/ffffff/external-edit-user-interface-anggara-basic-outline-anggara-putra-5.png")`,
            }}
            onClick={() => {
              this.props.appStore!.groupToEdit = this.props.group.group;
            }}
          />
        }
        <h2>{this.props.group?.group?.name}</h2>
        <div
          className='groupInvitationDescription'
          style={{
            height: this.props.style.height ? 120 : undefined
          }}
        >
          {this.props.group?.group?.description}
        </div>
        { }
        {this.props.group?.groupMemberInfo != undefined && this.props.group?.groupMemberInfo?.type &&
          <div className='groupInvitationType'>
            <>{`${window.loc.strings.yourSharedEnneagramType}: `}</><div className="yourSharedEnneagramType">{this.props.group?.groupMemberInfo?.type}</div>
          </div>
        }
        {this.props.group?.groupMemberInfo?.type &&
          <div
            className='groupInvitationDescription'
            style={{
              color: "lightgray"
            }}
          >
            {window.loc.strings.changeTypeInfo}
          </div>
        }
        {!this.props.isAdmin &&
          <div className="shareTypeToggle">
            {this.props.group?.groupMemberInfo == undefined ?
              <div
                className="groupButton"
                onClick={() => {
                  let result;
                  if (this.props.appStore!.selectedTestResult) {
                    result = this.props.appStore!.selectedTestResult.pointsForTypes.map((type: IType) => {
                      return {
                        id: type.id,
                        points: this.props.appStore!.selectedTestResult.splitTestResult && type.id === this.props.appStore!.selectedTestResult.splitTestResult ? type.points + 1 : type.points
                      }
                    });
                    result = this.props.appStore!.sortByKey(result, "id").reverse();
                  }

                  const sortedResult = this.props.appStore!.sortByKey(result, "points");
                  if (sortedResult?.length > 0) {
                    this.props.appStore!.selectedType = sortedResult[0].id;
                  }
                  this.props.group.groupMemberInfo = {
                    groupId: this.props.group?.group?.objectId || "",
                    userId: this.props.appStore!.user?.id || "",
                    type: this.props.appStore!.selectedType,
                    result: result
                  };
                  GroupService.createGroupMemberInfo(this.props.group.groupMemberInfo).then((id: string) => {
                    if (id != undefined) {
                      this.props.group.groupMemberInfo.objectId = id;
                      ProductService.allowAccessToProduct("19067", this.props.appStore!.user?.username || "", undefined, "Teamtest").then(() => {
                        this.props.getMyGroups(this.props.group);
                      });
                    }
                  })
                }}
              >
                {window.loc.strings.acceptInvitation.toUpperCase()}
              </div>
              :
              <>
                <div
                  className="groupButton"
                  onClick={() => {
                    GroupService.deleteGroupMemberInfo(this.props.group.groupMemberInfo.objectId).then(() => {
                      this.props.getMyGroups(this.props.group);
                    });
                  }}
                  style={{
                    backgroundColor: "gray"
                  }}
                >
                  {window.loc.strings.leaveGroup.toUpperCase()}
                </div>
                {!this.props.group?.groupMemberInfo?.type ? (
                  <div
                    className="groupButton"
                    onClick={() => {
                      window.open(`/tests/19067/test`, '_self');
                    }}
                  >
                    {window.loc.strings.takeTest.toUpperCase()}
                  </div>
                ) : (
                  (this.props.appStore!.selectedType != this.props.group?.groupMemberInfo?.type) ? (
                    <div
                      className="groupButton"
                      onClick={() => {
                        let result;
                        if (this.props.appStore!.selectedTestResult) {
                          result = this.props.appStore!.selectedTestResult.pointsForTypes.map((type: IType) => {
                            return {
                              id: type.id,
                              points: this.props.appStore!.selectedTestResult.splitTestResult && type.id === this.props.appStore!.selectedTestResult.splitTestResult ? type.points + 1 : type.points
                            }
                          });
                          result = this.props.appStore!.sortByKey(result, "id").reverse();
                        }
                        GroupService.deleteGroupMemberInfo(this.props.group.groupMemberInfo.objectId).then(() => {
                          this.props.group.groupMemberInfo = {
                            groupId: this.props.group.group.objectId,
                            userId: this.props.appStore!.user.id,
                            type: this.props.appStore!.selectedType,
                            result: result
                          };
                          GroupService.createGroupMemberInfo(this.props.group.groupMemberInfo).then((id: string) => {
                            if (id != undefined) {
                              this.props.group.groupMemberInfo.objectId = id;
                            }
                          });
                        });
                      }}
                    >
                      {window.loc.strings.updateType.toUpperCase()}
                    </div>
                  ) : (
                    <></>
                  )
                )}
              </>
            }
          </div>
        }
        {/* {((this.props.group?.group?.allowMembersToSeeResult && this.props.group?.groupMemberInfo != undefined) || this.props.group.group.admins.includes(this.props.appStore!.user?.id)) && */}
        {this.props.showResultButton && (
          // <div
          //   className="groupButton"
          //   style={{
          //     marginTop: 15,
          //   }}
          //   onClick={() => {
          //     this.props.appStore!.groupToView = this.props.group.group;
          //   }}
          // >
          //   {window.loc.strings.seeGroupResults.toUpperCase()}
          // </div>
          <a href={`/teamtest/?id=${this.props.group.group.objectId}`} target="_blank" rel="noreferrer"
            className="groupButton"
            style={{
              marginTop: 15,
              textDecoration: "none",
            }}
          >
            {window.loc.strings.seeGroupResults.toUpperCase()}
          </a>
        )}
      </div>
    );
  }
}